// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2svKB","messages":"Chat_messages__215FP","dateDivider":"Chat_dateDivider__oHFaN"};